import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-text text-muted" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-text text-muted" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-text text-muted" }

import { computed, toRef } from 'vue'

    import type { AttributeReadModel } from '@Alternatives/Attributes/Domain/readmodels'
    import type { FormReadModel } from '@Alternatives/Forms/Domain/readmodels'
    import type { ViewSettingsEditorViewModel } from '@Alternatives/AlternativesLists/Components/ViewSettingsEditor'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ViewSettingsEditor',
  props: {
    viewModel: {}
  },
  emits: ["saved"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const alternativesLabel = computed(() => vm.value.alternativesLabel)
    const forms = computed<FormReadModel[]>(() => vm.value.forms)
    const attributes = computed<AttributeReadModel[]>(() => vm.value.attributes)

    const listAttributes = computed(() =>
        attributes.value.filter(a => a.IsList === true)
    )

    // ---------------- writable computed (v-model targets) ----------------

    const formId = computed<number | null>({
        get: () => vm.value.formId,
        set: val => { vm.value.viewSettings.FormId = val }
    })

    const colorAttributeId = computed<number | null>({
        get: () => vm.value.colorAttributeId,
        set: val => { vm.value.viewSettings.ColorAttributeId = val }
    })

    const columnAttributeId = computed<number | null>({
        get: () => vm.value.columnAttributeId,
        set: val => { vm.value.viewSettings.ColumnAttributeId = val }
    })

    // ---------------- methods ----------------

    function confirm()
    {
        vm.value.save()
        emit('saved')
        close()
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "modal-title" }, "Configure View", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "Form:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formId).value = $event))
                  }, [
                    _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "All fields (default)", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forms.value, (f) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: f.Id
                      }, _toDisplayString(f.Name), 9 /* TEXT, PROPS */, _hoisted_7))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, formId.value]
                  ]),
                  _createElementVNode("small", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createTextVNode(" You can decide which form you want to open when you edit ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[6] || (_cache[6] = _createTextVNode(". Simply select the form on the drop-down. If you don't like any of the existing forms, why not create one of your own! ", -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", null, "Color:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((colorAttributeId).value = $event))
                  }, [
                    _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "None (default)", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listAttributes.value, (a) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: a.Id
                      }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, colorAttributeId.value]
                  ]),
                  _createElementVNode("small", _hoisted_11, [
                    _cache[9] || (_cache[9] = _createTextVNode(" You can color-code your ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[10] || (_cache[10] = _createTextVNode(" based on any category-based attribute. This will help you quickly eyeball your ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[11] || (_cache[11] = _createTextVNode(" and and get a feel for how many fall into each category. Simply select which attribute you want to use to color-code your ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[12] || (_cache[12] = _createTextVNode(" within the Kanban. ", -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", null, "Columns:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((columnAttributeId).value = $event))
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Status (default)", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listAttributes.value, (a) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: a.Id
                      }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_13))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, columnAttributeId.value]
                  ]),
                  _createElementVNode("small", _hoisted_14, [
                    _cache[15] || (_cache[15] = _createTextVNode(" By default, your Kanban will break ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[16] || (_cache[16] = _createTextVNode(" out by status. This lets you set out the \"workflow\" of ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[17] || (_cache[17] = _createTextVNode(", but sometimes you might want to see ", -1 /* CACHED */)),
                    _createElementVNode("em", null, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                    _cache[18] || (_cache[18] = _createTextVNode(" broken out by other factors. You can select any category-attribute simply by selecting that attribute from this menu... and when you're done, you can come back and change it back to status! ", -1 /* CACHED */))
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: confirm,
                  type: "button",
                  class: "btn btn-primary"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})